/** * * Asynchronously loads the component for
Manage Cards
* */ import { lazyLoad } from "utils/loadable";
export const ManageCards = lazyLoad(
  () => import("./index"),
  (module) => module.ManageCards
);
